import TermsOfService from "../components/Footer/TermsOfService";

function TermsOfServicePage() {
  return (
    <div>
      <TermsOfService />
    </div>
  );
}

export default TermsOfServicePage;
